export const appendSpinnerToFormButtons = (documentObject: Document, cssFormSelector: string) => {
    const form = documentObject.querySelector(cssFormSelector)
    if (form) {
        const buttons = form.querySelectorAll<HTMLOcButtonV1Element>("oc-button-v1[type='submit']")
        buttons.forEach((button) => {
            button.addEventListener("click", () => {
                spinnerButtonEventListener(button)
            })
        })
    }
}

export const appendSpinnerToButton = (button: HTMLOcButtonV1Element) => {
    button.addEventListener("click", () => {
        spinnerButtonEventListener(button)
    })
}

function spinnerButtonEventListener(button: HTMLOcButtonV1Element) {
    button.loading = true
    /*                                                                                         */
    setTimeout(() => (button.loading = false), 30_000)
}
